// src/components/Feed/Styles/MemberHome.Style.js
// @flow

// You had a "styles = (theme) => ({ root: {...}, setupMeeting: {...} })" object.
// We'll refactor that to an object of theme => style objects for MUI 5.

const memberHomeStyles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex',
    backgroundColor: 'white',
    marginLeft: 0,
    marginRight: 0
  }),

  setupMeeting: (theme) => ({
    minWidth: 400,
    minHeight: 300,
    width: 'calc(100vw - 100px)',
    zIndex: 99999,
    position: 'absolute',
    top: '55%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '1.2rem',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6)
  })
};

export default memberHomeStyles;